import {GenericItemsForm, GenericItemsUtils, IGetAllParams} from "@leap4/frontend";
import {baseBackendRoute} from "../../../config/generals";
import {Groups} from "@mui/icons-material";
import React from "react";

const fields = {name: 1, isActive: 1,  updated: 1, created: 1}
const getParams: IGetAllParams = {fields}
const {
    store,
    columns
} = GenericItemsUtils.GenerateDefaultStoreAndColumns({baseUrl: `${baseBackendRoute}/organizations`}, fields, {
    isActive: {},
    created: {},
    name: {editLinkFunc: (id) => `/organizations/${id}`},
    updated: {}
})


const OrganizationsTable = () => {

    return <GenericItemsForm store={store} columns={columns} getAllParams={getParams}
                             breadcrumbs={{
                                 link: "/organizations",
                                 text: "Organizations",
                                 icon: <Groups />
                             }}
                             createButton={{
                                 to: "/organizations/add",
                                 text: "Create Organization"
                             }}
    />
}

export {OrganizationsTable}
